<template>
    <div class="pin-configuration">
        <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"/>
        <b-card v-bind:title="titleCard" class="text-center" style="margin: 20px">
            <b-card-body>
                <div class="row mb-2">
                    <div class="col-md-12 text-center" v-if="showResultOK">
                        <span>
                            <i class="fa fa-fw fa-key" style="font-size:120px"/>
                        </span>
                    </div>
                    <div class="col-md-12 text-center" v-else>
                        <form autocomplete="off">
                            <div v-show="showOldPin">
                                <div>
                                    <!-- Evita interferir en el guardar/cambiar contraseña en chrome para el usuario logueado -->
                                    <base-input class="userName" value="oldpinuser" autocomplete="off" hidden/>
                                </div>
                                <pincode-input v-model="oldPin" ref="pincode-old-pin" secure autocomplete="off" :length="this.length"/>
                            </div>
                            <div v-show="showNewPin">
                                <div>
                                    <!-- Evita interferir en el guardar/cambiar contraseña en chrome para el usuario logueado -->
                                    <base-input class="userName" value="newpinuser" autocomplete="off" hidden/>
                                </div>
                                <pincode-input v-model="newPin" ref="pincode-new-pin" secure autocomplete="off" :length="this.length"/>
                            </div>
                            <div v-show="showRepeatNewPin">
                                <div>
                                    <!-- Evita interferir en el guardar/cambiar contraseña en chrome para el usuario logueado -->
                                    <base-input class="userName" value="repeatnewpinuser" autocomplete="off" hidden/>
                                </div>
                                <pincode-input v-model="repeatNewPin" ref="pincode-repeat-new-pin" secure autocomplete="off" :length="this.length"/>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-md-12 text-center">
                        <span>{{message}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 text-center" v-if="showResultOK">
                        <b-button class="btn btn-danger" @click="goToAfterFinish">Finalizar</b-button>                        
                    </div>
                    <div class="col-md-12 text-center" v-else>
                        <b-button class="btn btn-danger" @click="nextStep">Siguiente</b-button>
                    </div>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>

<style lang="scss">
    .pin-configuration {
        .card-title {
            color: #ff5855;
        }
    }
</style>

<script>
import PincodeInput from 'vue-pincode-input';
import generalHelpers from "@/helpers/generalHelpers";
import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";

export default {
    name: "PinConfiguration",
    components: {
        "pincode-input": PincodeInput
    },
    props: {
        currentPinProp: String,
        activatePinProp: {
            type: Boolean,
            default: false
        },
        forgotMyPINProp: {
            type: Boolean,
            default: false
        },
        routeGoToAfterFinishProp: {
            type: String,
            default: 'pin'
        }
    },
    data() {
        return {
            length: 6,
            currentPin: this.currentPinProp,
            activatePin: this.activatePinProp,
            forgotMyPIN: this.forgotMyPINProp,
            routeGoToAfterFinish: this.routeGoToAfterFinishProp,
            step: 0,
            oldPin: '',
            newPin: '',
            repeatNewPin: ''
        };
    },
    computed: {
        showOldPin() {
            return this.step == 0;
        },
        showNewPin() {
            return this.step == 1;
        },
        showRepeatNewPin() {
            return this.step == 2;
        },
        showResultOK() {
            return this.step == 3;
        },
        titleCard() {
            var res = '';

            switch (this.step) {
                case 0:
                    res = 'Ingresá tu PIN de ' + this.length + ' dígitos';
                    break;
                case 1:
                    res = 'Ingresá tu PIN de ' + this.length + ' dígitos';
                    break;
                case 2:
                    res = 'Reingresá el PIN de ' + this.length + ' dígitos';
                    break;
                case 3:
                    res = '¡Listo! Tu clave PIN de ' + this.length + ' dígitos quedó registrada';
                    break;
                default:
                    break;
            }

            return res;
        },
        message() {
            var res = '';

            switch (this.step) {
                case 0:
                    res = '';
                    break;
                case 1:
                    res = 'Registrá una nueva clave numérica de ' + this.length + ' dígitos.';
                    break;
                case 2:
                    res = 'Repetí el PIN ingresado así nos aseguramos que este correcto.';
                    break;
                case 3:
                    res = 'No la divulgues y recordá que solo te la vamos a pedir cuando realices una operación de egreso de dinero como Pagos con QR o Transferencias.';
                    break;
                default:
                    break;
            }

            return res;
        }        
    },
    methods: {
        nextStep() {
            let context = this;
            if(context.step == 0){
                if(context.validatePin(context, context.oldPin))
                {
                    context.step++;
                }
            } else if ( context.step == 1){
                if(context.validatePin(context, context.newPin))
                {
                    context.step++;
                }
            } else if(context.step == 2) {
                if(context.validatePin(context, context.repeatNewPin))
                {
                    context.setPinAccountValidation(context);
                }
            } 
        },
        validatePin(context, pin){
            if (pin == "") {
                notificationHelpers.showError(
                    "Error",
                    "Debe ingresar un Pin de Pago.",
                    context
                );
                return false;
            }
            
            if(pin.length != context.length){
                  notificationHelpers.showError(
                    "Error",
                    "Debe ingresar un Pin de " + context.length + " dígitos.",
                    context
                );
                return false;
            }

            if(generalHelpers.validateSameCharsInString(pin)) {
                notificationHelpers.showError("Error", "No pueden ser iguales todos los caracteres del Pin de Pago.", context);
                return false;
            }

            return true;
        },
        AddNewAttemptByAccount(context){
                 let req = {
                    AccumulationMethodTypeID: context.$store.getters.PERSONAL_DATA_UPDATE_ATTEMPTS_METHOD_TYPE_ID,
                    SecurityMethodID: context.$store.getters.PIN_SECURITY_METHOD_ID,
                    Reason: 'PIN Incorrecto'
                };

                axiosHelpers.axiosPost("DoubleFactorSecurity/AddNewAttemptByAccount", req, context, function(data) {});
        },
        setPinAccountValidation(context) {
            if(context.repeatNewPin != context.newPin) {
                notificationHelpers.showError("Error", "El pin y su confirmacion no concuerdan", context);
                context.cleanNewPin();
                context.cleanRepeatNewPin();
                context.step = 1;
                return;
            }            

            if(context.forgotMyPIN == false)
            {
                var oldPinMD5 = generalHelpers.convertStringToMD5(context.oldPin).toUpperCase();
                
                if(context.oldPin != '' && oldPinMD5 != context.currentPin) {   
                    context.AddNewAttemptByAccount(context);
                    
                    notificationHelpers.showError("Error", "El pin anterior no es correcto", context);
                    context.cleanOldPin();
                    context.step = 0;
                    return;
                }
            }

            context.setPinAccount(context);
        },
        setPinAccount(context) {
            var oldPinMD5 = context.forgotMyPIN ? context.currentPin : generalHelpers.convertStringToMD5(context.oldPin).toUpperCase();

            let req = { 
                LastPin: oldPinMD5,
                NewPin: context.newPin,
                ActivatePin: context.activatePin
            };

            axiosHelpers.axiosPost("Account/SetPinAccount", req, context, function(data) {
                if(data.ResponseVM.Result) {                    
                    context.step ++;
                }
            });
        },
        goToAfterFinish() {
            this.$router.push(this.routeGoToAfterFinish);
        },
        cleanOldPin() {
            if(this.$refs["pincode-old-pin"] != undefined) {
                this.$refs["pincode-old-pin"].letters.forEach(l => {
                    l.value = '';
                });
            }

            this.oldPin = '';
        },
        cleanNewPin() {
            if(this.$refs["pincode-new-pin"] != undefined) {
                this.$refs["pincode-new-pin"].letters.forEach(l => {
                    l.value = '';
                });
            }

            this.newPin = '';
        },
        cleanRepeatNewPin() {
            if(this.$refs["pincode-repeat-new-pin"] != undefined) {
                this.$refs["pincode-repeat-new-pin"].letters.forEach(l => {
                    l.value = '';
                });
            }

            this.RepeatNewPin = '';
        }
    },
    beforeMount() {        
        let context = this;

        if(context.forgotMyPINProp) {
            context.step = 1
        }
    }
}
</script>